import React from 'react'
import { graphql } from 'gatsby'

import Layout from '../components/layout'
import SEO from '../components/seo'
import ScrollToTop from '../components/scrollToTop'
import Img from 'gatsby-image'

function IndexPage({ data }) {
    // Variables
    const parsedData = data.allContentfulImage.edges
        .map((edges) => {
            return edges.node
        })
        .filter((data) => data.collection === null && data.image != null)

    return (
        <React.Fragment>
            <Layout>
                <SEO
                    keywords={[
                        `kevinlaminto`,
                        `kevin laminto`,
                        `kevin laminto photography`,
                        `kevin laminto aesthetic`,
                        `melbourne photographer`,
                        `melbourne fashion photographer`,
                    ]}
                    title='Portfolio'
                />

                <section onContextMenu={(e) => e.preventDefault()}>
                    {parsedData.map((data, index) => {
                        return (
                            <Img
                                className='mb-10'
                                key={index}
                                fluid={data.image.fluid}
                            />
                        )
                    })}
                </section>
            </Layout>
            <ScrollToTop />
        </React.Fragment>
    )
}

export default IndexPage

export const query = graphql`
    query HomePageQuery {
        allContentfulImage {
            edges {
                node {
                    collection
                    image {
                        fluid {
                            ...GatsbyContentfulFluid
                        }
                    }
                }
            }
        }
    }
`
